import { useQuery } from '@tanstack/react-query';
import { api } from '../utils/api';

export function useApi(path, options = {}) {
  const { queryKey, enabled, ...rest } = options;
  return useQuery({
    queryKey: queryKey || [path],
    queryFn: () => api(path),
    enabled: enabled !== undefined ? enabled && !!path : !!path,
    ...rest,
  });
}
